import cx from 'classnames';

import SpriteSvg from '../../assets/images/sprite.svg';

const Icon = ({ name, className }) => (
	<svg className={cx('icon', { [`${className}`]: className })}>
		<use xlinkHref={`${SpriteSvg}#${name}`} />
	</svg>
);

export default Icon;
